export const DomElementsIdentifiers = {
  footerSubmit: 'footerSubmit',
  notificationsBlock: 'notifications-block',
};
